import React, { useEffect, useState } from 'react'
import { usePartner } from '../../helpers/BrandPageAPI';
import cogoToast from 'cogo-toast';

const LinkExpiredCounter = () => {
    const { partnerData } = usePartner();
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (!partnerData?.ExpiredDateString) return;

        const [datePart, timePart] = partnerData.ExpiredDateString.split(" ");
        const [day, month, year] = datePart.split("-").map(Number);
        const [h, m, s] = timePart.split(":").map(Number);

        const targetDate = new Date(year, month - 1, day, h, m, s);
        const currentDate = new Date();
        const timeDifference = targetDate.getTime() - currentDate.getTime();

        if (timeDifference <= 0) {
            cogoToast.error("Link expired hot to page 404");
            
            return;
        }

        const totalSeconds = Math.floor(timeDifference / 1000);
        const hRemaining = Math.floor(totalSeconds / 3600);
        const mRemaining = Math.floor((totalSeconds % 3600) / 60);
        const sRemaining = totalSeconds % 60;

        setHours(hRemaining);
        setMinutes(mRemaining);
        setSeconds(sRemaining);
    }, [partnerData]);


    // Countdown logic
    useEffect(() => {
        const timer = setInterval(() => {
            if (hours === 0 && minutes === 0 && seconds === 0) {
                clearInterval(timer);
                return;
            }
            if (seconds > 0) {
                setSeconds(prev => prev - 1);
            } else if (minutes > 0) {
                setMinutes(prev => prev - 1);
                setSeconds(59);
            } else if (hours > 0) {
                setHours(prev => prev - 1);
                setMinutes(59);
                setSeconds(59);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [hours, minutes, seconds]);

    // const format = num => num.toString().padStart(2, "0");
    return (
        <div className='d-flex align-items-center gap-2'>
            LinkExpire After  :
            <div className="expire_duration">
                <p className="text-center">
                    {String(hours).padStart(2, '0')}
                </p>
                {/* Hourse */}
            </div> :
            <div className="expire_duration">
                <p className="text-center">
                    {String(minutes).padStart(2, '0')}
                </p>
                {/* Minute */}
            </div> :
            <div className="expire_duration">
                <p className="text-center">
                    {String(seconds).padStart(2, '0')}
                </p>
                {/* Second */}
            </div>
        </div>
    )
}

export default LinkExpiredCounter